import { Mail } from "lucide-react";

const KIND = {
  intake: "Intake link to client",
  review: "Review link to client",
  alias_intake_submitted: "Alias: intake received",
  alias_draft_ready: "Alias: draft ready",
  alias_generation_failed: "Alias: generation failed",
  alias_client_changes: "Alias: client changes",
  alias_client_approved: "Alias: client approved",
};
const TONE = {
  sent: "text-emerald-300 bg-emerald-500/10 ring-emerald-500/30",
  failed: "text-rose-300 bg-rose-500/10 ring-rose-500/30",
  blocked: "text-amber-300 bg-amber-500/10 ring-amber-500/30",
  skipped: "text-slate-300 bg-slate-500/10 ring-slate-500/30",
};
const LABEL = { sent: "Accepted by mail server", failed: "Failed", blocked: "Blocked", skipped: "Not sent" };

export const EmailLog = ({ emails, configured, automation }) => (
  <section className="rounded-2xl bg-slate-900/70 ring-1 ring-slate-800 p-4" data-testid="email-log">
    <p className="text-[11px] uppercase tracking-wide text-slate-400 mb-2 flex items-center gap-1.5"><Mail className="h-3.5 w-3.5" /> Emails</p>
    {!configured && <p className="text-sm text-amber-300 mb-2" data-testid="email-not-configured">Email sending is not configured — nothing is sent.</p>}
    {automation && !automation.allowed && <p className="text-sm text-amber-300 mb-2" data-testid="email-automation-off">{automation.reason}</p>}
    {emails.length === 0 ? <p className="text-sm text-slate-500" data-testid="email-log-empty">No emails yet.</p> : (
      <ul className="space-y-2">
        {[...emails].reverse().map((e) => (
          <li key={e.id} data-testid={`email-${e.id}`} className="flex flex-wrap items-center gap-2 text-sm">
            <span className={`rounded-md px-2 py-0.5 text-xs ring-1 ${TONE[e.status] || TONE.skipped}`} data-testid={`email-status-${e.id}`}>{LABEL[e.status] || e.status}</span>
            <span className="text-slate-200">{KIND[e.kind] || e.kind}{e.stage ? ` (${e.stage === "final" ? "final" : "first draft"})` : ""}</span>
            <span className="text-slate-500">{e.to || "—"} · {new Date(e.at).toLocaleString()}</span>
            {e.status !== "sent" && <span className="w-full text-xs text-slate-500">{e.detail}</span>}
          </li>
        ))}
      </ul>
    )}
  </section>
);
